<template>
  <ul v-if="benefits" class="benefit-list" :class="`benefit-list--${size}`">
    <li v-for="(benefit, index) in benefits" :key="index">
      <Icon
        v-if="benefit.icon"
        class="text-primary"
        :size="size === 'lg' ? 36 : 24"
        :style="size === 'lg' ? 'min-width: 36px' : 'min-width: 24px'"
        :name="!benefit.icon ? 'fa6-regular:circle-check' : String(benefit.icon)"
      />
      <RichTextRenderer v-if="benefit.text" :document="benefit.text" />
    </li>
  </ul>
</template>
<script lang="ts" setup>
import type { BenefitListItemStoryblok } from '~/types/storyblok'

withDefaults(
  defineProps<{
    benefits?: BenefitListItemStoryblok[]
    size?: '' | 'sm' | 'lg' | 'default' | null
  }>(),
  {
    benefits: undefined,
    size: 'default',
  },
)
</script>

<style lang="less" scoped>
ul.benefit-list {
  .list-reset();

  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  margin: 0.75em 0 1.25em;

  @media @desktop {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: @gutter-xl;
  }

  li {
    display: flex;
    align-items: center;
    gap: @gutter;
    padding: @gutter-sm 0;
    border-bottom: @1px solid fade(@state-info, 20%);

    @media @desktop {
      padding: @gutter 0;
    }

    span {
      flex-shrink: 0;
    }
  }

  &.without-border {
    li {
      border: none;
    }
  }

  &.benefit-list--sm {
    .font-sm();
    grid-template-columns: repeat(1, minmax(0, 1fr));

    li {
      padding: @gutter-sm 0 @gutter;
      gap: @gutter-sm;
    }
  }

  &.benefit-list--lg {
    .font-lg();
    grid-template-columns: repeat(2, minmax(0, 1fr));

    li {
      padding: @gutter-xl 0 @gutter-lg;
      gap: @gutter-md;
    }
  }
}
</style>
